import React from 'react';
import CalltoActionEight from "../../elements/calltoaction/CalltoActionEight";
import CopyrightTwo from "./CopyrightTwo";
import ScrollTop from "./ScrollTop";


const FooterThree = () => {
    return (
        <>
            <div className="footer-style-2">
                <CalltoActionEight />
                <CopyrightTwo />
            </div>
            <ScrollTop />
        </>
    )
}
export default FooterThree;